import { getMarginBottom } from "components/common/inputScales";
import { createThemedUseStylesWithParams } from "theme";

import { Header4Props } from "./Header4Types";

export default createThemedUseStylesWithParams<Header4Props>(
  (params, theme) => ({
    h4: {
      marginTop: 0,
      marginLeft: 0,
      marginRight: 0,
      marginBottom: getMarginBottom(params.stackSpacing, theme)
    }
  })
);
